import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

const noop = () => {};

class Modal extends Component {
  static propTypes = {
    children: PropTypes.any,
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string,
    onAfterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
  }

  static defaultProps = {
    title: undefined,
    onAfterOpen: noop,
    onRequestClose: noop,
  }

  handleAfterOpen = (e) => {
    this.props.onAfterOpen(e);
  }

  handleRequestClose = (e) => {
    this.props.onRequestClose(e);
  }

  render () {
    const { children, isOpen, title } = this.props;

    return (
      <ReactModal
        isOpen={isOpen}
        onAfterOpen={this.handleAfterOpen}
        onRequestClose={this.handleRequestClose}
        className="Modal"
        overlayClassName="Modal-overlay"
        bodyOpenClassName="overflow-hidden"
        contentLabel="Modal">
        <a href="#" className="Modal-closeButton position-relative" onClick={this.handleRequestClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
            <path fill="#808080" fillRule="evenodd" d="M5.12830091,3.42946782 L1.82257674,0.123743653 L-0.0512562993,1.99757669 L3.25446787,5.30330086 L-0.0512562993,8.60902503 L1.82257674,10.4828581 L5.12830091,7.1771339 L8.43402507,10.4828581 L10.3078581,8.60902503 L7.00213394,5.30330086 L10.3078581,1.99757669 L8.43402507,0.123743653 L5.12830091,3.42946782 Z"/>
          </svg>
          <span className="visibility-hidden position-absolute">Close</span>
        </a>
        <div className="Modal-body" role="document">
          {title && <h1 className="text-5 text-7-m fontWeight-semibold marginBottom-16">{title}</h1>}
          {children}
        </div>
      </ReactModal>
    );
  }
}

export default Modal;
